export default "__VITE_PUBLIC_ASSET__14ce115a__"